var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text',{ref:"self",attrs:{"config":_vm.item},on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }